import { z } from "zod/v4";

export const ShopifyWebhookMetafieldSchema = z.object({
  id: z.number(),
  namespace: z.string(),
  key: z.string(),
  value: z.any(),
  description: z.string().nullable(),
  owner_id: z.number(),
  owner_resource: z.string(),
  type: z.string(),
  admin_graphql_api_id: z.string(),
});

export const ShopifyWebhookProductVariantSchema = z.object({
  id: z.number(),
  product_id: z.number(),
  title: z.string(),
  price: z.string(),
  compare_at_price: z.string().nullable(),
});

export const ShopifyWebhookProductBodySchema = z.object({
  id: z.string(),
  title: z.string(),
  handle: z.string(),
  tags: z.string(),
  variants: ShopifyWebhookProductVariantSchema.array().default([]),
  metafields: ShopifyWebhookMetafieldSchema.array().optional().default([]),
});

export type ShopifyWebhookProductBodyType = z.infer<
  typeof ShopifyWebhookProductBodySchema
>;
